import React from 'react';
import { Button, forwardRef } from '@chakra-ui/react';
import { CloseSolidCircleIcon } from '@allergan-data-labs/alle-elements-icons/16/closeSolidCircleIcon';
import type { ChipCloseButtonProps } from './chip-types';
import { getChipCloseButtonStyles } from './chip.theme';

export const ChipCloseButton = forwardRef<ChipCloseButtonProps, 'button'>(
  (
    { onClose, 'aria-label': ariaLabel, colorScheme, colorMode, ...rest },
    ref
  ) => {
    const handleKeydown = (event: React.KeyboardEvent) => {
      const SPACE_KEY_CODE = 'Space';
      const ENTER_KEY_CODE = 'Enter';
      const key = event.key || event.code;
      if (key === SPACE_KEY_CODE || key === ENTER_KEY_CODE) {
        event.preventDefault();
        onClose?.();
      }
    };
    return (
      <Button
        ref={ref}
        sx={getChipCloseButtonStyles({ colorMode, colorScheme })}
        onKeyDown={handleKeydown}
        onClick={onClose}
        aria-label={ariaLabel || 'Close'}
        {...rest}
      >
        <CloseSolidCircleIcon />
      </Button>
    );
  }
);
